<header class="header">
  <div class="container header-container">
    <div class="header-content">
      <div class="logo-container">
        <a routerLink="/home" class="logo">
          <img
            ngSrc="page_logo.png"
            alt="LIV635 Logo"
            width="120"
            height="32"
            priority
            class="logo-image"
          />
        </a>
      </div>
      <nav class="nav-menu">
        <div class="nav-links">
          <a routerLink="/home" routerLinkActive="active" class="nav-link">Início</a>
          <a routerLink="/home" routerLinkActive="active" class="nav-link" (click)="navigateToProperties($event)">
            Imóveis
          </a>
        </div>
        <button class="btn-subtle nav-button-desktop" (click)="openContactModal()">Entrar em contato</button>
        <button class="nav-menu-toggle" (click)="toggleMobileMenu()">
          <lucide-icon name="Menu" class="icon-24" />
        </button>
      </nav>
      @if (mobileMenuOpen()) {
        <div class="mobile-menu-overlay" (click)="toggleMobileMenu()"></div>
        <div class="mobile-menu">
          <a routerLink="/home" routerLinkActive="active" class="mobile-nav-link" (click)="toggleMobileMenu()">Início</a>
          <a routerLink="/home" routerLinkActive="active" class="mobile-nav-link" (click)="navigateToProperties($event); toggleMobileMenu()">Imóveis</a>
          <button class="btn-subtle mobile-nav-button" (click)="openContactModal()">Entrar em contato</button>
        </div>
      }
    </div>
  </div>
</header>

